/**
 * iOS Safari 输入框聚焦后会自动放大页面，失焦后有时无法恢复。
 * 根因通常是 input 字体 < 16px；此处作为兜底，在失焦时强制重置 viewport。
 */
export function initIosInputZoomFix() {
  const isIOS =
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)

  if (!isIOS) return

  const resetViewportScale = () => {
    const meta = document.querySelector('meta[name="viewport"]')
    if (!meta) return

    const original = meta.getAttribute('content')
    if (!original) return

    meta.setAttribute(
      'content',
      `${original}, maximum-scale=1.0, user-scalable=no`
    )

    requestAnimationFrame(() => {
      meta.setAttribute('content', original)
    })
  }

  document.addEventListener(
    'focusout',
    (event) => {
      const target = event.target
      if (
        !target ||
        !target.matches('input, textarea, select, [contenteditable="true"]')
      ) {
        return
      }

      // 等待软键盘收起后再重置
      setTimeout(resetViewportScale, 100)
    },
    true
  )
}
